import { Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";

export const ThemeToggle = ({ className = "" }) => {
  const { resolvedTheme, setTheme } = useTheme();
  const dark = resolvedTheme === "dark";
  return (
    <button
      type="button"
      onClick={() => setTheme(dark ? "light" : "dark")}
      className={`inline-flex h-9 w-9 items-center justify-center rounded-lg border bg-card transition-colors hover:bg-muted ${className}`}
      aria-label={dark ? "Ativar tema claro" : "Ativar tema escuro"}
      data-testid="theme-toggle-btn"
    >
      {dark ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
    </button>
  );
};
